/*
 * @ Author: wangjiyu
 * @Date: 2019-12-19 09:52:52
 * @LastEditTime : 2021-09-13 10:25:03
 * @LastEditors  : 蔡传明
 * @Description: file content
 */
import { action } from 'mobx';
import toast from '@util/toast';

import { DataLogCodeModel, DataLogCodeStatus, DataLoginToken, HasLogin, GetPhoneCode, Logout, DataLoginIM } from './Login/Login';
import { ArticleListModel, ArticleDeleteModel, ArticleImmediatePub, ArticleDetail, ArticleCreateUpdate, ArticleSaveDraft, ArticlePreviewQrcode } from './ArticleModel/ArticleModel';
import { StsWrite, StsRead, StsUpload, Snapshots, PlayInfo, UploadImg, GetImgInfoModel, GetBosImgInfoModel, GetOasBosImgInfoModel } from './OtherModel/OtherModel';
// 问答
import { AddQuestion, PublicQuestion, AnswerList, GetDetail, MyQuestionList } from './Question';
// 帖子
import { VideoList, AddPics, PicsList, EditPicsList } from './PostsModel';
// 视频
import { CreateVideoState, VideoRelease } from './Video';

import {auth, IdaasLogin, getToken,initZeus} from "../util/auth";


export class Store {
           public dataLogCodeModel = new DataLogCodeModel();
           public dataLoginIM = new DataLoginIM();
           public dataLogCodeStatus = new DataLogCodeStatus();
           public dataLoginToken = new DataLoginToken();
           public articleListModel = new ArticleListModel();
           public articleDeleteModel = new ArticleDeleteModel();
           public articleImmediatePub = new ArticleImmediatePub();
           public articleDetail = new ArticleDetail();
           public articleCreateUpdate = new ArticleCreateUpdate();
           public articleSaveDraft = new ArticleSaveDraft();
           public stsWrite = new StsWrite();
           public StsRead = new StsRead();
           public stsUpload = new StsUpload();
           public snapshots = new Snapshots();
           public playInfo = new PlayInfo();
           public uploadImg = new UploadImg();
           public getImgInfoModel = new GetImgInfoModel();
           public getBosImgInfoModel = new GetBosImgInfoModel();
           public getOasBosImgInfoModel = new GetOasBosImgInfoModel();
           public hasLogin = new HasLogin();
           public getPhoneCode = new GetPhoneCode();
           public logout = new Logout();
           public addQuestion = new AddQuestion();
           public publicQuestion = new PublicQuestion();
           public createVideoState = new CreateVideoState();
           public videoRelease = new VideoRelease();
           public answerList = new AnswerList();
           public getDetail = new GetDetail();
           public videoList = new VideoList();
           public addPics = new AddPics();
           public picsList = new PicsList();
           public editPicsList = new EditPicsList();
           public myQuestionList = new MyQuestionList();
           public getArticlePreviewQrcode = new ArticlePreviewQrcode();

           // ==============================

           public unonload = window.onunload;
           constructor() {
               console.log('Store>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>init');
               const USERINFO =  localStorage.getItem('USERINFO')
               console.log("USERINFO===>",USERINFO);
               initZeus(USERINFO?JSON.parse(USERINFO):{});
           }

           @action public reset() {
               // this.currencyModel = new currencyClass()
           }

           @action public hasLoginManage = (fn?) => {
               this.hasLogin
                   .init()
                   .then(async(res) => {
                      // const isAuthenticated = await auth.isAuthenticated();
                      // console.log('判断登录状态成功===>', res, isAuthenticated);
                      // if (!isAuthenticated) {
                      //   IdaasLogin();
                      // } else {
                      //   const userInfo = await auth.getUser();
                      //   getToken()
                      //   console.log("🎉恭喜你，登录成功", userInfo);
                      // }
                       // this.getLoginCodeStatus(this.securityStr, res.qrCode);
                       // window.location.href = '/';

                      //  getToken()
                       fn && fn(true);
                   })
                   .catch((err) => {
                       console.log('判断登录状态失败====>', err);
                       // setTimeout(() => {
                       if (fn) {
                           fn(false);
                       } else {
                           window.location.href = '/login';
                       }
                       // }, 3000);
                   });
           };
       }
const storeIntance = new Store();
export default storeIntance;
